import { useContext, useEffect, useRef, startTransition } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { History } from "@shopify/app-bridge/actions";
import { AppBridgeContext } from "./AppBridgeProvider";
import { toRouterPath } from "../utils/appPaths";

/**
 * App Bridge → React Router: sidebar / admin back-forward updates the SPA route.
 */
export default function AppHistorySync() {
  const app = useContext(AppBridgeContext);
  const location = useLocation();
  const navigate = useNavigate();
  const locationRef = useRef(location);
  const navigateRef = useRef(navigate);

  locationRef.current = location;
  navigateRef.current = navigate;

  useEffect(() => {
    if (!app) return undefined;

    const history = History.create(app);
    const unsubscribers = [];

    const syncFromBridge = (payload) => {
      const rawPath =
        (typeof payload === "string" && payload) ||
        payload?.path ||
        payload?.payload?.path ||
        "";
      if (!rawPath) return;
      const routerPath = toRouterPath(rawPath.split("?")[0]);
      const search = rawPath.includes("?") ? rawPath.slice(rawPath.indexOf("?")) : locationRef.current.search;
      if (routerPath && routerPath !== locationRef.current.pathname) {
        startTransition(() => {
          navigateRef.current({ pathname: routerPath, search }, { replace: true });
        });
      }
    };

    try {
      unsubscribers.push(history.subscribe(History.Action.PUSH, syncFromBridge));
      unsubscribers.push(history.subscribe(History.Action.REPLACE, syncFromBridge));
    } catch (e) {
      console.warn("[AppHistorySync] subscribe failed:", e?.message || e);
    }

    return () => {
      unsubscribers.forEach((unsub) => {
        try {
          if (typeof unsub === "function") unsub();
        } catch {
          /* noop */
        }
      });
    };
  }, [app]);

  return null;
}
